import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { profileApi } from '@/services/api/profile';
import type { UpdateProfileRequest } from '@/types/profile';

const PROFILE_KEY = ['profile'] as const;

export function useProfile() {
  return useQuery({
    queryKey: PROFILE_KEY,
    queryFn: async () => {
      const res = await profileApi.getProfile();
      return res.data.data;
    },
  });
}

export function usePublicProfile() {
  return useQuery({
    queryKey: ['public-profile'],
    queryFn: async () => {
      const res = await profileApi.getPublicProfile();
      return res.data.data;
    },
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: UpdateProfileRequest) => {
      const res = await profileApi.updateProfile(data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROFILE_KEY });
    },
  });
}

export function useUploadAvatar() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (file: File) => {
      const imageUrl = await profileApi.uploadAvatar(file);
      return { imageUrl };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROFILE_KEY });
    },
  });
}

export function useSetAvatarUrl() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (imageUrl: string) => {
      await profileApi.setAvatarUrl(imageUrl);
      return { imageUrl };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROFILE_KEY });
    },
  });
}
